export default "__VITE_ASSET__BB$oNDfO__"